// extracted by mini-css-extract-plugin
export default {"favActive":"favActive--lgXJj","description":"description--wnDJV"};